import { InputFormCallout, InputFormCalloutProps, TextInput, uniqueGUID } from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";
import { IntegerInput } from "../IntegerInput/IntegerInput";

export const enum Fields {
  CoreCount = "coreCount",
  RequestedCoreCount = "requestedCoreCount",
  NodeCount = "nodeCount"
}

export interface ScaleConfig {
  defaultValue: number | undefined;
  min?: number | undefined;
  max?: number | undefined;
  nodeCount?: number | undefined;
}
export interface ConfigCoreCountPanelProps extends
  Pick<InputFormCalloutProps, "title" | "targetId" | "onClose" | "onSubmit" | "componentRef" | "primaryButtonText">
{
   scaleConfig: ScaleConfig | undefined;
}

export const ConfigCoreCountPanel = ({
  title,
  onClose,
  onSubmit,
  targetId,
  primaryButtonText,
  scaleConfig,
  componentRef,
}: ConfigCoreCountPanelProps): JSX.Element => {
  const [requestedCoreCount, setRequestedCoreCount] = React.useState<number>(
    (scaleConfig?.defaultValue || scaleConfig?.min || 0) * (scaleConfig?.nodeCount || 1),
  );
  const [mountKey, setMountKey] = React.useState<string>(uniqueGUID());

  const onChangeCoreCount = (value: number): void => {
    setRequestedCoreCount(value * (scaleConfig?.nodeCount || 1));
    setMountKey(uniqueGUID());
  };

  return (
    <InputFormCallout
      componentRef={componentRef}
      title={title || ""}
      targetId={targetId}
      onClose={onClose}
      onSubmit={onSubmit}
      primaryButtonText={primaryButtonText}
    >
      <IntegerInput
        required
        defaultValue={scaleConfig?.defaultValue}
        label={Messages.labels.ocpuCountPerVM()}
        fieldName={Fields.CoreCount}
        min={scaleConfig?.min}
        max={scaleConfig?.max}
        onChange={value => { onChangeCoreCount(value); }}
      />
      <TextInput
        defaultValue={scaleConfig?.nodeCount?.toString()}
        label={Messages.labels.nodeCount()}
        fieldName={Fields.NodeCount}
        readOnly
      />
      <TextInput
        key={mountKey}
        defaultValue={requestedCoreCount.toString()}
        label={Messages.labels.requestedOCPUCount()}
        fieldName={Fields.RequestedCoreCount}
        readOnly
      />
    </InputFormCallout>
  );
};
